export const FilterType = {
  DATE: 2,
  DATE_RANGE: 4,
  SINGLE_DROPDOWN: 8,
  MULTI_DROPDOWN: 16
}

export const ORDER_FILTER_STATUS = [
  { label: 'common_all', value: 'all' },
  // -------------- common ---------------------
  // { label: 'order_status_psb', value: 'psb' },
  // { label: 'order_status_fll', value: 'fll' },
  // { label: 'order_status_alf', value: 'alf' },
  // { label: 'order_status_can', value: 'can' },
  // { label: 'order_status_rej', value: 'rej' },
  // { label: 'order_status_spp', value: 'spp' },
  // { label: 'order_status_pxp', value: 'pxp' },
  // { label: 'order_status_exp', value: 'exp' },
  // { label: 'order_status_iav', value: 'iav' },
  // { label: 'order_status_bix', value: 'bix' },
  // { label: 'order_status_stb', value: 'stb' },
  // { label: 'order_status_ack', value: 'ack' },
  // { label: 'order_status_bpm', value: 'bpm' },
  // { label: 'order_status_cpd', value: 'cpd' },
  // { label: 'order_status_mpa', value: 'mpa' },
  // { label: 'order_status_mxs', value: 'mxs' },
  // { label: 'order_status_sor', value: 'sor' },
  // -------------- common ---------------------
  { label: 'order_status_scb_iat', value: 'iav,soi' },
  { label: 'order_status_scb_bix', value: 'bix,pex,exp' },
  { label: 'order_status_scb_bpm', value: 'bpm' },
  { label: 'order_status_scb_rej', value: 'rej,kll' },
  { label: 'order_status_scb_can', value: 'can' },
  { label: 'order_status_scb_fll', value: 'fll' },
  { label: 'order_status_scb_mps', value: 'mps' },
  // { label: 'order_status_scb_pex', value: 'pex,exp' },
  { label: 'order_status_scb_new', value: 'psb,stb,bms,bss,cmo,msd,new' },
  { label: 'order_status_scb_wa', value: 'pap,mpa' },
  { label: 'order_status_scb_cpd', value: 'cpd' },
  { label: 'order_status_sor', value: 'sor' },
  { label: 'order_status_scb_snd', value: 'snd' },
  { label: 'order_status_exp', value: 'exp' },
  { label: 'order_status_scb_pxp', value: 'pxp' },
]

export const TRANSACTION_TYPE = [
  { label: 'common_all', value: 'ALL' },
  { label: 'transType_SCAS', value: 'SCAS' },
  { label: 'transType_SCCB', value: 'SCCB' },
  { label: 'transType_CCPCD', value: 'CCPCD' },
  { label: 'transType_CCPCW', value: 'CCPCW' },
  { label: 'transType_SCAC', value: 'SCAC' },
  { label: 'transType_SCAXW', value: 'SCAXW' },
  { label: 'transType_SCAXD', value: 'SCAXD' },
  { label: 'transType_SCATW', value: 'SCATW' },
  { label: 'transType_SCATD', value: 'SCATD' },
  { label: 'transType_CCIPOS', value: 'CCIPOS' },
  { label: 'transType_SCCS', value: 'SCCS' },
  { label: 'transType_SCPSD', value: 'SCPSD' },
  { label: 'transType_SCPSW', value: 'SCPSW' },
  { label: 'transType_SCAVD', value: 'SCAVD' },
  { label: 'transType_SCAVW', value: 'SCAVW' },
  { label: 'transType_SCAIW', value: 'SCAIW' }
]